module.exports = __webpack_public_path__ + "img/arrival-shield.e1e11ee1.svg";